<template>
    <router-view> </router-view>
</template>

<script>
import socket from './scripts/Socket.js';

export default {
  name: 'App',
  data() {
    return {
      socket: null,
      session: {authToken: '', initialData: null}
    };
  },
  methods: {
    setAuthToken(authToken){
      localStorage.setItem('authToken', authToken);
      this.session.authToken = authToken;
    }
  },
  provide() {
    return {
      initSocket: socket,
      socket: this.socket,
      authToken: this.authToken,
      setAuthToken: this.setAuthToken,
      session: this.session,
    };
  },
  created() {
    const token = localStorage.getItem('authToken');
    this.setAuthToken(token ? token : '');
  },
}
</script>

<style>
/* Importing Fonts */
@import url('https://fonts.googleapis.com/css2?family=Jost&display=swap');

#app{
  --team-blue: #007965;
  --team-red: #a20a0a;
}
.flexbox{
    display: flex;
}
.hr-separator{
  border-top: 1px solid rgb(0, 0, 0);
  box-shadow: 0px 0px 2px 2px rgb(0, 0, 0);
  margin-left: 8px;
  margin-right: 8px;
  transition: all 0.32s;
}
.fullscreen{
    position: fixed;
    padding: 0;
    margin: 0;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
}
.block{
  display: block;
}
.bottom{
  margin-bottom: 8px;
}
.fade-in{
    animation: fadeIn ease 0.8s;
}
fade-in-quick{
    animation: fadeIn ease 0.4s;
}
@keyframes fadeIn{
    0%{
        opacity: 0;
    }
    100%{
        opacity: 1;
    }
}
@keyframes fadeOut{
    0%{
        opacity: 1;
    }
    100%{
        opacity: 0;
    }
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
  
::selection{
  background-color: rgba(0, 0, 0, 0.301);
}
</style>
